/**
 * 描述：租户管理--信息源订阅设置--地区相关官员
 * 日期：2018-5-3
 * 作者：gao_kaizhi
 */
'use strict';
angular.module('regionRealtedOfficialsModule', []).controller('regionRealtedOfficialsCtrl', [
    '$scope',
    'trsspliceString',
    '$q',
    '$filter',
    'tManageMentService',
    'modalDialog',
    'trsHttpService',
    '$state',
    function($scope, trsspliceString, $q, $filter, tManageMentService, modalDialog, trsHttpService, $state) {
        initStatus();
        initData();

        /** [initStatus description: 初始化状态] */
        function initStatus() {
            $scope.status = {
                hotWarnShow: false,
                linkXinHua: false,
                linkChengPin: false,
            };
            $scope.page = {
                PAGESIZE: 10,
                ITEMCOUNT: 0,
                CURRPAGE: 1,
                PAGECOUNT: 1,
            };
            $scope.data = {
                copyCurrPage: 1,
                disaster: [],
                fieldHotList: [],
                areaHotList: [],
                RregionData: '',
                areaInterOrConutry: [],
                leaderList: [], // 官员数组
                selectedLeader: [], // 勾选中的官员ID数组
                searchword: '',
                tenantInfo: {}, // 租户信息
            };
            $scope.isShowImg = false;
        }

        /** [initData description： 初始化数据] */
        function initData() {
            requestRregionData();
            requestInfo().then(function(id) {
                $scope.id = id;
                requestField(id);
                queryLeaderInfo(id);
                requestDisaster();
            });
        }

        /** [requestInfo description:获取企业的具体信息] */
        function requestInfo() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_tenant',
                methodName: 'findTenantById',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.tenantInfo = data;
                $scope.status.linkXinHua = data.PICKUPXINHUAAGENCY === '1';
                $scope.status.linkChengPin = data.PICKUPENDPRODUCT === '1';
                $scope.startTime = data.STARTTIME;
                $scope.endTime = data.ENDTIME;
                $scope.qiyong = data.STATUS;
                $scope.tenantName = data.TENANTNAME;
                deffer.resolve(data.TENANTID);
            });
            return deffer.promise;
        }

        /** [leaderSreach description： 检索查询租户的官员信息] */
        $scope.leaderSreach = function() {
            var searchParams = {
                serviceid: 'mlf_tenant',
                methodName: 'queryTenantRelevantInfos',
                SearchField: $scope.data.searchword,
                TENANTID: $scope.id,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchParams, 'post').then(function(data) {
                $scope.data.leaderList = [];
                for (var i = 0; i < data.length - 1; i++) {
                    $scope.data.leaderList.push(data[i]);
                }
                $scope.page.PAGECOUNT = data[data.length - 1].PAGECOUNT;
                $scope.page.ITEMCOUNT = data[data.length - 1].TOTALNUMBERS;
            });
        };

        /** [singleDelete description： 删除租户关心的领导人信息] */
        $scope.singleDelete = function(item) {
            modalDialog.alertType(
                '',
                '确定删除该信息？',
                'warning',
                true,
                function() {
                    var singleParams = {
                        serviceid: 'mlf_tenant',
                        methodName: 'delallTenantRelevantInfo',
                        ObjectIds: item.TENANTRELEVANTINFOID,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), singleParams, 'post').then(function() {
                        modalDialog.alertType('', '官员删除成功!', 'success', false);
                        queryLeaderInfo($scope.id);
                    });
                },
                function() {}
            );
        };

        /** [deleteSelectLeader description: 批量删除选中的官员信息] */
        $scope.deleteSelectLeader = function() {
            modalDialog.alertType(
                '',
                '确定删除选中信息?',
                'warning',
                true,
                function() {
                    var IDstr = $scope.data.selectedLeader.join(',');
                    var params = {
                        serviceid: 'mlf_tenant',
                        methodName: 'delallTenantRelevantInfo',
                        ObjectIds: IDstr,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        if (data.ISSUCCESS == 'true') {
                            modalDialog.alertType('', '官员删除成功!', 'success', false);
                            queryLeaderInfo($scope.id);
                        }
                    });
                },
                function() {}
            );
        };

        /** [selectLeaderAll description:领导人勾选的全选按钮] */
        $scope.selectLeaderAll = function() {
            if ($scope.data.selectedLeader.length === $scope.data.leaderList.length && $scope.data.leaderList.length > 0) {
                $scope.data.selectedLeader = [];
            } else {
                $scope.data.selectedLeader = [];
                for (var i = 0; i < $scope.data.leaderList.length; i++) {
                    $scope.data.selectedLeader.push($scope.data.leaderList[i].TENANTRELEVANTINFOID);
                }
            }
        };

        /** [selectLeader description: 领导人勾选的回调函数] */
        $scope.selectLeader = function(item) {
            var num = $scope.data.selectedLeader.indexOf(item.TENANTRELEVANTINFOID);
            if (num > -1) {
                $scope.data.selectedLeader.splice(num, 1);
            } else {
                $scope.data.selectedLeader.push(item.TENANTRELEVANTINFOID);
            }
        };

        /** [requestDisaster description: 租户查询自己订阅的灾害信息] */
        function requestDisaster() {
            if ($scope.data.tenantInfo.DISASTERWARNING === undefined) {
                return;
            }
            var arr = $scope.data.tenantInfo.DISASTERWARNING.split(',');
            var params = {
                serviceid: 'mlf_tenant',
                methodName: 'initTenantDisaster',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                for (var i = 0; i < data.length; i++) {
                    if (arr.indexOf(data[i].id) > -1) {
                        $scope.data.disaster.push(data[i]);
                    }
                }
            });
        }

        /**
         * [requestField description]查询租户的领域热点
         * @param  {[type]} id [description]租户ID
         * @return {[type]}    [description]
         */
        function requestField(id) {
            if ($scope.data.tenantInfo.TENANTAREAS === undefined) {
                return;
            }
            var arr = $scope.data.tenantInfo.TENANTAREAS.split(',');
            var params = {
                serviceid: 'mlf_tenant',
                methodName: 'initTenantAreaByAdmin',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                for (var i = 0; i < data.length; i++) {
                    if (arr.indexOf(data[i].ID) > -1) {
                        $scope.data.fieldHotList.push(data[i]);
                    }
                }
            });
        }

        /** [link description: 改变稿库接入的状态] */
        $scope.link = function(item) {
            checkIPForlink().then(function(flag) {
                if (item === 1) {
                    $scope.status.linkXinHua = !$scope.status.linkXinHua;
                    if ($scope.status.linkXinHua) {
                        modalDialog.alertType('', '稿库接入,需先进入“稿库接入设置”是否进行设置？', 'ask', true, function() {
                            $state.go('manageconfig.tenantmanagement.manuAccessSetting');
                        });
                    }
                } else {
                    $scope.status.linkChengPin = !$scope.status.linkChengPin;
                    if ($scope.status.linkChengPin) {
                        modalDialog.alertType('', '稿库接入,需先进入“稿库接入设置”是否进行设置？', 'ask', true, function() {
                            $state.go('manageconfig.tenantmanagement.manuAccessSetting');
                        });
                    }
                }
                var params = {
                    serviceid: 'mlf_tenant',
                    methodname: 'updateTenantInfo',
                    ObjectId: $scope.id,
                    STARTTIME: $scope.startTime,
                    ENDTIME: $scope.endTime,
                    STATUS: $scope.qiyong,
                    PICKUPXINHUAAGENCY: $scope.status.linkXinHua == true ? '1' : '0',
                    PICKUPENDPRODUCT: $scope.status.linkChengPin == true ? '1' : '0',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function() {
                    requestInfo();
                });
            });
        };

        /** [checkIPForlink description]检验是否已经完成了稿库接入设置 */
        function checkIPForlink() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_tenantuploadmanage',
                methodName: 'queryTenantUploadManage',
                TENANTNAME: $scope.tenantName,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(res) {
                if (angular.isArray(res)) {
                    // 因为后端的不正常规格数据返回做了如此判断
                    deffer.resolve(false);
                } else {
                    deffer.resolve(true);
                }
            });
            return deffer.promise;
        }

        /** [handleAreaHotList description: 处理地域热点的数据 以16条为界限初始时最多显示16条] */
        function handleAreaHotList() {
            var num = $scope.data.areaHotList.length > 16 ? 16 : $scope.data.areaHotList.length;
            $scope.showAreaHotList = [];
            for (var i = 0; i < num; i++) {
                $scope.showAreaHotList.push($scope.data.areaHotList[i]);
            }
        }

        /** [requestRregionData description: 获取企业的数据地域信息] */
        function requestRregionData() {
            var params = {
                serviceid: 'mlf_tenant',
                methodName: 'Decode',
                TENANTID: $scope.id,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                data = eval(data);
                data = eval(data);
                if (data != '') {
                    for (var i = data[0].length - 1; i > -1; i--) {
                        $scope.data.RregionData += data[0][i].dictName;
                        if (i != 0) {
                            $scope.data.RregionData += '-';
                        }
                    }
                } else {
                    $scope.data.RregionData = '暂无数据地域信息';
                }
            });
        }

        /** [queryLeaderInfo description]查询租户的领导人信息 */
        function queryLeaderInfo(id) {
            var params = {
                serviceid: 'mlf_tenant',
                methodName: 'queryTenantRelevantInfos',
                TENANTID: id,
                Page_NO: $scope.page.CURRPAGE,
                Page_Size: $scope.page.PAGESIZE,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.leaderList = [];
                for (var i = 0; i < data.length - 1; i++) {
                    $scope.data.leaderList.push(data[i]);
                }
                $scope.page.PAGECOUNT = data[data.length - 1].PAGECOUNT;
                $scope.page.ITEMCOUNT = data[data.length - 1].TOTALNUMBERS;
            });
        }

        /** [requestData description]当分页发生变化时相求请求相应的数据 */
        $scope.requestData = function() {
            queryLeaderInfo($scope.id);
        };

        /** [jumpToPage description] 当页面发生跳转时完成对选择页面的数据输入并请求数据 */
        $scope.jumpToPage = function() {
            $scope.page.CURRPAGE = $scope.data.copyCurrPage;
            queryLeaderInfo($scope.id);
        };

        /** [editTenantOff description:编辑领导人信息] */
        $scope.editTenantOff = function(item) {
            tManageMentService.regionalOfficia(item).then(function(data) {
                if (data.ISSUCCESS == 'true') {
                    modalDialog.alertType('', '修改成功!', 'success', false);
                    queryLeaderInfo($scope.id);
                } else {
                    modalDialog.alertType('', '修改失败!', 'error', false);
                }
            });
        };

        /** [createNewLeader description:新建租户关心的地域相关官员] */
        $scope.createNewLeader = function() {
            tManageMentService.regionalOfficia().then(function(data) {
                if (data.ISSUCCESS == 'true') {
                    modalDialog.alertType('', '新建成功!', 'success', false);
                    queryLeaderInfo($scope.id);
                } else {
                    modalDialog.alertType('', '新建失败!', 'error', false);
                }
            });
        };

        /** [showMoreArea description: 点击展开获得更多的地域数据] */
        $scope.showMoreArea = function() {
            for (var i = 16; i < $scope.data.areaHotList.length; i++) {
                $scope.showAreaHotList.push($scope.data.areaHotList[i]);
            }
        };

        /** [stopAreaList description: 收起。。只展示16条数据] */
        $scope.stopAreaList = function() {
            $scope.showAreaHotList.splice(16, $scope.data.areaHotList.length - 16);
        };

        /** [ManuLibraryAcc description: 稿库接入设置] */
        $scope.ManuLibraryAcc = function() {
            $state.go('manageconfig.tenantmanagement.manuAccessSetting');
            $scope.$emit('f5', true);
        };
    },
]);
